<template>
  <div class="xang-dau-component-wrapper">
    <button
      class="action-card-btn action-card-btn--fuel"
      aria-label="Báo Cáo Đổ Xăng"
      @click="openModal"
      :disabled="isBusy"
    >
      <i class="fa fa-bolt" aria-hidden="true"></i>
      <span class="label">ĐỔ NHIÊN LIỆU</span>
    </button>

    <div
      v-if="showModal"
      class="modal fade show d-block modal-overlay"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg modal-full-mobile" role="document">
        <div class="modal-content">
          <form @submit.prevent="handleSubmit" novalidate>
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title font-weight-bold">
                <i class="fa fa-bolt mr-2"></i>Báo Cáo Đổ Nhiên Liệu
              </h5>
              <button
                type="button"
                class="close text-white"
                @click="closeModal"
                :disabled="isBusy"
              >
                <span>&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <div v-if="formError" class="alert alert-danger py-2">
                {{ formError }}
              </div>

              <div class="form-group">
                <label
                  >1. Ảnh Chụp Biên Lai
                  <span class="text-danger">*</span></label
                >
                <button
                  type="button"
                  class="btn btn-outline-primary btn-block btn-lg-custom"
                  :disabled="isBusy || uploadingBienLai || isBienLaiMax"
                  @click="openCameraFor('bienLai')"
                >
                  <i class="fa fa-camera mr-1"></i>
                  <span v-if="!isBienLaiMax"
                    >Chụp ảnh Biên lai ({{ form.anhBienLaiUrls.length }}/{{
                      maxBienLai
                    }})</span
                  >
                  <span v-else>Đã đủ {{ maxBienLai }} ảnh</span>
                  <span
                    v-if="uploadingBienLai"
                    class="spinner-border spinner-border-sm ml-1"
                  ></span>
                </button>

                <div
                  v-if="form.anhBienLaiUrls.length"
                  class="preview-list-scroll mt-2"
                >
                  <div
                    v-for="(url, idx) in form.anhBienLaiUrls"
                    :key="'bl-' + idx"
                    class="preview-item"
                  >
                    <img
                      :src="url"
                      class="preview-img-thumb"
                      alt="Biên lai"
                      @click="openImagePreview(url)"
                    />
                    <div class->
                      <span class="badge badge-secondary badge-main">{{
                        idx === 0 ? "Chính" : idx + 1
                      }}</span>
                      <button
                        type="button"
                        class="btn-remove-img"
                        @click="removeBienLai(idx)"
                        :disabled="isBusy"
                        aria-label="Xoá ảnh"
                      >
                        &times;
                      </button>
                    </div>
                  </div>
                </div>
                <small class="text-muted d-block mt-1">
                  Có thể chụp tối đa {{ maxBienLai }} ảnh.
                </small>
                <input
                  type="text"
                  :value="form.anhBienLaiUrls[0]"
                  required
                  style="display: none"
                  tabindex="-1"
                  aria-hidden="true"
                  @focus.prevent
                />
              </div>

              <div class="form-group">
                <label
                  >2. Ảnh Chụp Đồng Hồ ODO
                  <span class="text-danger">*</span></label
                >
                <button
                  type="button"
                  class="btn btn-outline-primary btn-block btn-lg-custom"
                  :disabled="isBusy || uploadingOdo || isOdoMax"
                  @click="openCameraFor('odo')"
                >
                  <i class="fa fa-camera mr-1"></i>
                  <span v-if="!isOdoMax"
                    >Chụp ảnh ODO ({{ form.anhOdoUrls.length }}/{{
                      maxOdo
                    }})</span
                  >
                  <span v-else>Đã đủ {{ maxOdo }} ảnh</span>
                  <span
                    v-if="uploadingOdo"
                    class="spinner-border spinner-border-sm ml-1"
                  ></span>
                </button>
                <div
                  v-if="form.anhOdoUrls.length"
                  class="preview-list-scroll mt-2"
                >
                  <div
                    v-for="(url, idx) in form.anhOdoUrls"
                    :key="'odo-' + idx"
                    class="preview-item"
                  >
                    <img
                      :src="url"
                      class="preview-img-thumb"
                      alt="ODO"
                      @click="openImagePreview(url)"
                    />
                    <div class->
                      <span class="badge badge-secondary badge-main">{{
                        idx === 0 ? "Chính" : idx + 1
                      }}</span>
                      <button
                        type="button"
                        class="btn-remove-img"
                        @click="removeOdo(idx)"
                        :disabled="isBusy"
                        aria-label="Xoá ảnh"
                      >
                        &times;
                      </button>
                    </div>
                  </div>
                </div>
                <small class="text-muted d-block mt-1">
                  Có thể chụp tối đa {{ maxOdo }} ảnh.
                </small>
                <input
                  type="text"
                  :value="form.anhOdoUrls[0]"
                  required
                  style="display: none"
                  tabindex="-1"
                  aria-hidden="true"
                  @focus.prevent
                />
              </div>

              <hr />

              <div class="form-row">
                <div class="form-group col-12">
                  <label>3. Đơn giá (đ / lít) <span class="text-danger">*</span></label>
                  <input
                    v-model="formattedDonGia"
                    type="text"
                    inputmode="numeric"
                    pattern="[0-9,]*"
                    class="form-control form-control-lg"
                    required
                    placeholder="Nhập giá tiền / lít"
                  />

                  <!-- Cảnh báo đơn giá bất thường -->
                  <small
                    v-if="isDonGiaSuspicious"
                    class="text-warning d-block mt-1"
                  >
                    ⚠️ Đơn giá có vẻ không hợp lý. Đây là
                    <strong>ĐƠN GIÁ / LÍT</strong>, không phải tổng số tiền.
                    Vui lòng kiểm tra lại.
                  </small>

                  <!-- Tổng tiền ước tính từ ĐƠN GIÁ * SỐ LÍT -->
                  <small
                    v-if="soTienTinhToan"
                    class="text-muted d-block mt-1"
                  >
                    ~ Tổng tiền ước tính: {{ formatCurrency(soTienTinhToan) }}
                  </small>
                </div>

                <div class="form-group col-12 col-md-6">
                  <label>4. Số Lít <span class="text-danger">*</span></label>
                  <input
                    v-model.number="form.soLit"
                    type="number"
                    inputmode="decimal"
                    class="form-control form-control-lg"
                    min="0.1"
                    step="0.01"
                    required
                    placeholder="Nhập số lít đổ"
                  />
                </div>
                <div class="form-group col-12 col-md-6">
                  <label>5. Số ODO (Km) <span class="text-danger">*</span></label>
                  <input
                    v-model.number="form.odoKmCuoiKy"
                    type="number"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    class="form-control form-control-lg"
                    min="1"
                    required
                    placeholder="Km trên đồng hồ"
                  />
                </div>
              </div>

              <div class="mb-2 d-flex flex-wrap gap-1">
                <small class="col-12 p-0 mb-1">Gợi ý nhanh (Số lít):</small>

                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  @click="setSoLit(50)"
                >
                  50 lít
                </button>

                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  @click="setSoLit(100)"
                >
                  100 lít
                </button>

                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  @click="setSoLit(150)"
                >
                  150 lít
                </button>

                <button
                  type="button"
                  class="btn btn-sm btn-outline-secondary"
                  @click="form.soLit = null"
                >
                  Xoá
                </button>
              </div>
              <hr />

              <div class="form-group">
                <label>Ghi chú</label>
                <textarea
                  v-model.trim="form.ghiChu"
                  class="form-control"
                  rows="2"
                  placeholder="Ghi chú dành cho tài xế..."
                ></textarea>
              </div>
            </div>

            <div class="modal-footer sticky-footer-mobile">
              <button
                type="button"
                class="btn btn-outline-secondary btn-lg-custom"
                @click="closeModal"
                :disabled="isBusy"
              >
                Hủy
              </button>
              <button
                type="submit"
                class="btn btn-primary btn-lg-custom"
                :disabled="isBusy"
              >
                <span
                  v-if="isBusy"
                  class="spinner-border spinner-border-sm"
                ></span>
                <i v-else class="fa fa-paper-plane"></i> Gửi Báo Cáo
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      v-if="previewOpen"
      class="modal fade show d-block preview-overlay"
      tabindex="-1"
      @click="closeImagePreview"
    >
      <div class="d-flex align-items-center justify-content-center h-100">
        <img :src="previewUrl" class="preview-img" />
      </div>
    </div>

    <FullscreenCamera
      v-model="cameraCtx.open"
      :title="cameraTitle"
      :busy="isBusy"
      initial-facing="environment"
      @confirm="onCameraConfirm"
    />
  </div>
</template>

<script>
// ----- SCRIPT (ĐÃ BỔ SUNG LẠI CÁC TÍNH NĂNG) -----
import { mapState, mapActions } from "pinia";
import { useDriverXangDauStore } from "@/stores/driverXangDauStore";
import fileService from "@/services/fileService";
import FullscreenCamera from "@/components/FullscreenCamera.vue";

const DEFAULT_FORM = {
  soTien: null,
  soLit: null,
  odoKmCuoiKy: null,
  anhBienLaiUrls: [],
  anhOdoUrls: [],
  ghiChu: "",
};

export default {
  name: "XangDauComponent",
  components: {
    FullscreenCamera,
  },
  props: {
    xeId: { type: Number, required: true },
  },
  emits: ["submit-success"],
  data() {
    return {
      showModal: false,
      form: { ...DEFAULT_FORM },
      formError: null,
      submitting: false,
      uploadingBienLai: false,
      uploadingOdo: false,
      previewOpen: false,
      previewUrl: "",
      cameraCtx: {
        open: false,
        target: null, // 'bienLai' | 'odo'
      },
      maxBienLai: 5,
      maxOdo: 5,
    };
  },
  computed: {
    ...mapState(useDriverXangDauStore, ["isLoading", "error"]),
    isBusy() {
      return (
        this.isLoading ||
        this.uploadingBienLai ||
        this.uploadingOdo ||
        this.submitting
      );
    },

    formattedDonGia: {
      get() {
        if (!this.form.donGia) return "";
        return this.form.donGia.toLocaleString("vi-VN");
      },
      set(value) {
        const numericValue = parseInt(String(value).replace(/[^0-9]/g, ""), 10);
        this.form.donGia = isNaN(numericValue) ? null : numericValue;
      },
    },

    soTienTinhToan() {
      if (!this.form.donGia || !this.form.soLit || this.form.soLit <= 0) {
        return 0;
      }

      const raw = Number(this.form.donGia) * Number(this.form.soLit);
      if (!isFinite(raw)) return 0;

      // Làm tròn chuẩn theo bội 1.000
      return Math.round(raw / 1000) * 1000;
    },



    isDonGiaSuspicious() {
      const d = this.form.donGia;
      if (!d) return false;

      // tuỳ anh chỉnh lại min/max nếu muốn
      const MIN = 10000;  // 10k / lít
      const MAX = 40000;  // 40k / lít

      return d < MIN || d > MAX;
    },


    donGia() {
      if (!this.form.soTien || !this.form.soLit || this.form.soLit <= 0)
        return null;
      const val = Number(this.form.soTien) / Number(this.form.soLit);
      return isFinite(val) ? Math.round(val) : null;
    },
    isBienLaiMax() {
      return this.form.anhBienLaiUrls.length >= this.maxBienLai;
    },
    isOdoMax() {
      return this.form.anhOdoUrls.length >= this.maxOdo;
    },
    cameraTitle() {
      if (this.cameraCtx.target === "bienLai") return "chụp ảnh Biên lai";
      if (this.cameraCtx.target === "odo") return "chụp ảnh đồng hồ ODO";
      return "chụp ảnh";
    },

    // [THÊM LẠI] - Computed cho "Số Tiền"
    formattedSoTien: {
      get() {
        if (!this.form.soTien) {
          return "";
        }
        return this.form.soTien.toLocaleString("vi-VN");
      },
      set(value) {
        const numericValue = parseInt(String(value).replace(/[^0-9]/g, ""), 10);
        this.form.soTien = isNaN(numericValue) ? null : numericValue;
      },
    },
  },
  methods: {
    ...mapActions(useDriverXangDauStore, ["submitXangDauLog"]),

    // [THÊM LẠI] - Method cho "Quick Fill"
    setSoLit(value) {
      this.form.soLit = value;
    },

    openModal() {
      if (!this.xeId) {
        alert("Lỗi: Không tìm thấy thông tin xe được phân công.");
        return;
      }
      this.form = { ...DEFAULT_FORM, anhBienLaiUrls: [], anhOdoUrls: [] };
      this.formError = null;
      this.showModal = true;
      document.body.style.overflow = "hidden";
    },
    closeModal() {
      this.showModal = false;
      document.body.style.overflow = "";
    },

    openCameraFor(target) {
      if (target === "bienLai" && this.isBienLaiMax) return;
      if (target === "odo" && this.isOdoMax) return;
      this.cameraCtx.target = target;
      this.cameraCtx.open = true;
    },

    removeBienLai(idx) {
      this.form.anhBienLaiUrls.splice(idx, 1);
    },
    removeOdo(idx) {
      this.form.anhOdoUrls.splice(idx, 1);
    },

    async onCameraConfirm({ blob }) {
      if (!blob || !this.cameraCtx.target) return;
      const isBienLai = this.cameraCtx.target === "bienLai";
      // ... (logic kiểm tra max, giữ nguyên) ...

      if (isBienLai) this.uploadingBienLai = true;
      else this.uploadingOdo = true;
      this.formError = null;

      try {
        const rawFile = new File(
          [blob],
          `${isBienLai ? "bienlai" : "odo"}_${Date.now()}.jpg`,
          { type: "image/jpeg" }
        );
        const compressed = await this.compressImage(rawFile, {
          maxW: 1600,
          maxH: 1600,
          quality: 0.82,
        });
        const formData = new FormData();
        formData.append("files", compressed, rawFile.name);
        formData.append("folderName", "xang_dau");

        const res = await fileService.upload(formData);
        const first = Array.isArray(res.data) ? res.data[0] : null;
        if (!first?.location) {
          throw new Error("Server không trả về URL file.");
        }

        if (isBienLai) {
          this.form.anhBienLaiUrls.push(first.location);
        } else {
          this.form.anhOdoUrls.push(first.location);
        }
        this.cameraCtx.open = false;
      } catch (err) {
        console.error("Lỗi upload Xăng Dầu (camera):", err);
        this.formError =
          err?.response?.data?.error ||
          err?.message ||
          "Upload file thất bại.";
      } finally {
        if (isBienLai) this.uploadingBienLai = false;
        else this.uploadingOdo = false;
      }
    },

    async handleSubmit() {
      this.formError = null;

      // Ảnh
      if (!this.form.anhBienLaiUrls.length || !this.form.anhOdoUrls.length) {
        this.formError =
          "Vui lòng chụp đủ ảnh: ít nhất 1 Biên lai và 1 ODO.";
        return;
      }

      // ĐƠN GIÁ
      if (!this.form.donGia || this.form.donGia < 1000) {
        this.formError = "Vui lòng nhập Đơn giá hợp lệ (>= 1.000 đ/lít).";
        return;
      }

      // SỐ LÍT
      if (!this.form.soLit || this.form.soLit <= 0) {
        this.formError = "Vui lòng nhập Số lít hợp lệ (> 0).";
        return;
      }

      // ODO
      if (!this.form.odoKmCuoiKy || this.form.odoKmCuoiKy <= 0) {
        this.formError = "Vui lòng nhập ODO hợp lệ.";
        return;
      }

      if (this.submitting) return;
      this.submitting = true;

      try {
        const tongTien = Math.round(this.soTienTinhToan || 0);

        const payload = {
          xeId: this.xeId,
          donGia: this.form.donGia,      // ĐƠN GIÁ / LÍT
          soLit: this.form.soLit,        // SỐ LÍT
          soTien: tongTien,              // TỔNG TIỀN (có thể cho null, BE tự tính)
          odoKmCuoiKy: this.form.odoKmCuoiKy,
          anhBienLaiUrl: this.form.anhBienLaiUrls[0] || null,
          anhOdoUrl: this.form.anhOdoUrls[0] || null,
          bienLaiUrls: this.form.anhBienLaiUrls,
          odoUrls: this.form.anhOdoUrls,
          ghiChu: this.form.ghiChu || null,
        };

        const newLog = await this.submitXangDauLog(payload);

        this.closeModal();
        alert(
          `Đã gửi báo cáo xăng dầu thành công! (Tổng tiền: ${this.formatCurrency(
            newLog?.soTien ?? tongTien
          )})`
        );
        this.$emit("submit-success", newLog || payload);
      } catch (e) {
        this.formError =
          this.error || e?.message || "Lỗi không xác định khi gửi báo cáo.";
      } finally {
        this.submitting = false;
      }
    },


    // ... (logic compressImage, preview, formatCurrency, giữ nguyên) ...
    compressImage(file, { maxW = 1600, maxH = 1600, quality = 0.82 } = {}) {
      // ... (Giữ nguyên code nén ảnh) ...
      return new Promise((resolve, reject) => {
        try {
          const img = new Image();
          const url = URL.createObjectURL(file);
          img.onload = () => {
            let { width, height } = img;
            const ratio = Math.min(maxW / width, maxH / height, 1);
            width = Math.round(width * ratio);
            height = Math.round(height * ratio);
            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);
            canvas.toBlob(
              (blob) => {
                URL.revokeObjectURL(url);
                if (!blob) return reject(new Error("Không tạo được blob ảnh."));
                const compressedFile = new File(
                  [blob],
                  file.name.replace(/\.(\w+)$/, "_min.$1"),
                  {
                    type: blob.type || "image/jpeg",
                    lastModified: Date.now(),
                  }
                );
                resolve(compressedFile);
              },
              "image/jpeg",
              quality
            );
          };
          img.onerror = () => {
            URL.revokeObjectURL(url);
            reject(new Error("Không đọc được ảnh."));
          };
          img.src = url;
        } catch (err) {
          reject(err);
        }
      });
    },
    openImagePreview(url) {
      if (!url) return;
      this.previewUrl = url;
      this.previewOpen = true;
      document.body.style.overflow = "hidden";
    },
    closeImagePreview() {
      this.previewOpen = false;
      this.previewUrl = "";
      if (this.showModal) document.body.style.overflow = "hidden";
      else document.body.style.overflow = "";
    },

    formatCurrency(value) {
      if (value == null || isNaN(Number(value))) return "-";
      const raw = Number(value);
      const rounded = Math.round(raw / 1000) * 1000;
      return rounded.toLocaleString("vi-VN") + " đ";
    },


  },
};
</script>

<style scoped>
/* [XÓA BỎ] - Lỗi nghiêm trọng, gây ra không cuộn được */
/*
.modal {
  overflow-y: scroll !important; 
}
*/

/* [SỬA LẠI] - Nút chính, dùng layout DỌC (icon trên, chữ dưới) */
.action-card-btn {
  width: 100%;
  height: 100%;
  min-height: 92px;
  border: 0;
  border-radius: 14px;
  padding: 14px 12px;
  color: #fff;
  font-weight: 800;
  text-align: center; /* Căn giữa chữ */
  display: flex;
  flex-direction: column; /* DỌC */
  align-items: center; /* Căn giữa icon */
  justify-content: center; /* Căn giữa theo chiều dọc */
  gap: 10px;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);
  transition: transform 0.05s ease, filter 0.15s ease, opacity 0.15s ease;
  -webkit-tap-highlight-color: transparent;
}
.action-card-btn i {
  font-size: 22px; /* Cho icon to hơn chút */
  line-height: 1;
}
.action-card-btn .label {
  font-size: 16px;
  line-height: 1.15;
  letter-spacing: 0.2px;
}
/* ... (các :active, :focus, :disabled giữ nguyên) ... */
.action-card-btn:active {
  transform: translateY(1px);
  filter: brightness(0.96);
}
.action-card-btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.25);
}
.action-card-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  filter: grayscale(0.1);
}

/* Màu nút (giữ nguyên) */
.action-card-btn--fuel {
  background: #28a745;
}
@media (hover: hover) {
  .action-card-btn--fuel:hover {
    filter: brightness(1.05);
  }
}

/* ========== [SỬA LẠI] - Toàn bộ CSS cho Modal Fullscreen Mobile ========== */

/* 1. Lớp phủ */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  overflow-y: auto; /* Cho phép cuộn trên desktop */
  -webkit-overflow-scrolling: touch;
}

/* 2. Dialog */
.modal-full-mobile {
  width: 100%;
  margin: 1rem auto; /* Canh giữa trên desktop */
  max-width: 500px; /* Giới hạn chiều rộng desktop */
}

/* 3. Kích hoạt Flexbox (QUAN TRỌNG) */
@media (max-width: 576px) {
  .modal-full-mobile {
    margin: 0;
    max-width: 100%;
    height: 100%;
  }

  .modal-full-mobile .modal-content {
    height: 100dvh; /* 100% chiều cao màn hình động */
    border-radius: 0;
    display: flex;
    flex-direction: column; /* Xếp header-body-footer theo cột */
  }

  .modal-full-mobile .modal-body {
    flex-grow: 1; /* [CHÌA KHÓA] - Chỉ body được cuộn */
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    background-color: #fff;
    height: 100%;
    
  }
}

/* 4. Footer (Không cần "sticky" nữa, flexbox tự đẩy xuống) */
.sticky-footer-mobile {
  flex-shrink: 0; /* Ngăn footer bị co lại */
  background: #fff;
  z-index: 2;
  border-top: 1px solid #dee2e6;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
/* ========== HẾT PHẦN SỬA MODAL ========== */

/* Input và Nút (to, dễ bấm) */
.modal-body .form-control-lg {
  padding-top: 0.9rem;
  padding-bottom: 0.9rem;
  font-size: 1.15rem;
  font-weight: 500;
}
.modal-body .btn-lg-custom {
  padding: 0.75rem 1rem;
  font-size: 1.1rem;
  font-weight: 500;
}
.modal-footer .btn-lg-custom {
  padding: 0.6rem 1.25rem;
  font-size: 1.1rem;
  font-weight: 500;
}
.gap-1 {
  gap: 0.25rem;
}

/* Preview ảnh (giữ nguyên) */
.preview-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
}
.preview-img {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 8px;
  background: #fff;
}

/* [SỬA LẠI] - List cuộn ngang cho ảnh thumbnail */
.preview-list-scroll {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  padding-bottom: 12px; /* Cho thanh cuộn (nếu có) */
  gap: 0.75rem;
}

.preview-item {
  position: relative;
  flex-shrink: 0; /* Ngăn item bị co lại */
}

.preview-img-thumb {
  width: 96px;
  height: 96px; /* Vuông cho đẹp */
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #eee;
  cursor: zoom-in;
}

/* Nút xoá ảnh (chuyên nghiệp) */
.btn-remove-img {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 24px;
  height: 24px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 16px;
  font-weight: bold;
  line-height: 22px;
  text-align: center;
  padding: 0;
  cursor: pointer;
}

.badge-main {
  position: absolute;
  bottom: 6px;
  left: 6px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
}
</style>